export default "__VITE_ASSET__dcb00e33__"